import { Autocomplete } from "@mui/material";
import { useState, useEffect } from "react";
import { TextField } from "@mui/material";
import TextInput from "./TextInput";
import axiosInstance from "../utils/axiosInstance";
import { Spinner } from "flowbite-react";

export default function CompanySelector({
  selectedCompany,
  setSelectedCompany,
}) {
  const [companies, setCompanies] = useState([]);
  useEffect(() => {
    axiosInstance
      .get("/v51/companies")
      .then((res) => {
        setCompanies(
          res.data?.map((company) => ({
            label: company.name,
            value: company.id,
          })),
        );
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);

  if (!companies?.length) {
    return <Spinner />;
  }
  return (
    <Autocomplete
      value={selectedCompany}
      onChange={(event, newValue) => {
        setSelectedCompany(newValue.label);
      }}
      disablePortal
      id="combo-box"
      options={companies}
      renderInput={(params) => {
        return <TextField {...params} label="Company Name" />;
      }}
    />
  );
}
